import { put, select } from 'redux-saga/effects';

import { listSavedFilingPeriodFilesRequest } from '@actions/savedFilingPeriod';
import { FILE_GROUPS } from '@constants/fileGroups';
import { CATEGORY_CHOICES } from '@constants/vatReturns';
import { selectedFilingPeriodSelector } from '@store/selectors/savedFilingPeriod';

export const fetchFilesListSaga = function* () {
  const { id } = yield select(selectedFilingPeriodSelector);

  yield put(
    listSavedFilingPeriodFilesRequest({
      id,
      categories: [CATEGORY_CHOICES.CALCULATIONS, CATEGORY_CHOICES.POST_CONVERSION],
      filesMapGroup: FILE_GROUPS.WORKING_FILES,
    })
  );
  yield put(
    listSavedFilingPeriodFilesRequest({
      id,
      categories: [CATEGORY_CHOICES.SUPPORTING_DOCUMENT],
    })
  );
  yield put(
    listSavedFilingPeriodFilesRequest({
      id,
      categories: [CATEGORY_CHOICES.PROOF_PAYMENT],
    })
  );
  yield put(
    listSavedFilingPeriodFilesRequest({
      id,
      categories: [CATEGORY_CHOICES.VAT_RETURN],
    })
  );
};
